import React from "react";
import { Button } from "antd";

import style from "./homeworkLine.module.scss";
import { HomeworkListItem } from "API";
import { number2Hanzi, sectionDescribe } from "Utils/filter";
import { IHandleHomework } from "pages/HomeworkList";

import moment from "moment";

interface HomeworkLineProps {
    courseInfo: HomeworkListItem;
    status: string;
    btnText: string;
    handleHomework: IHandleHomework;
}

const HomeworkLine = ({
    courseInfo: {
        endDate,
        courseName,
        teacherName,
        weekTime,
        week,
        section,
        continunity,
        courseNo,
        courseSeq,
        score,
        paperId,
        weekTimeId
    },
    status,
    btnText,
    handleHomework
}: HomeworkLineProps) => {
    return (
        <div className={style.homeworkLine}>
            <div>
                <p className={style.endDate}>截止日期：{endDate}</p>
                <p className={style.courseName}>{courseName}</p>
                <p className={style.week}>
                    第{number2Hanzi(parseInt(weekTime))}周 周
                    {number2Hanzi(parseInt(week) + 1)}{" "}
                    {sectionDescribe(section, continunity)}
                </p>
                {status === "2" && <p>分数：{score}分</p>}
            </div>
            <div>
                <Button
                    disabled={
                        status === "3" && moment().isAfter(endDate, "day")
                    }
                    type="primary"
                    onClick={() =>
                        handleHomework(
                            courseNo,
                            courseSeq,
                            weekTime,
                            week,
                            section,
                            continunity,
                            status,
                            paperId,
                            weekTimeId
                        )
                    }>
                    {btnText}
                </Button>
            </div>
        </div>
    );
};

export default HomeworkLine;
